module.exports = __webpack_public_path__ + "img/album07_05.c36d4741.jpg";